export interface Dividend {
  isin: string;
  instrumentName: string;
  historicalPeriods: DividendPeriod[];
  forecastedPeriods: DividendPeriod[];
}

export interface DividendPeriod {
  period: string;
  dividendAbsolute: number;
  selfForecasted: boolean;
}

export interface DividendByInstrument {
  instrumentName: string;
  dividendAbsolute: number;
}

export enum DividendType {
  Historical = 'historical',
  Forecast = 'forecast',
}
